/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
import { BlockTypes } from "../Constants/BlockTypes";
import { findFieldBlocksOfType } from "./HtmlUtils";
export var findCaptchaBlock = function (formPlaceholders) {
    var captchaBlocks = formPlaceholders.flatMap(function (placeholder) {
        return Array.from(findFieldBlocksOfType(placeholder, BlockTypes.blockTypeCaptcha));
    });
    return captchaBlocks.length > 0 ? captchaBlocks[0] : null;
};
